import React, { useEffect } from "react";
import "../App.css";
import { clearScoreCardsByType } from "../actions/getScoreCardsByTypeActions";
import { useDispatch } from "react-redux";
import { clearOrganizationInfo } from "../features/organization/actions";

const LoginLayout = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearScoreCardsByType());
    dispatch(clearOrganizationInfo());
  }, []);

  return (
    <React.Fragment>
      <div className="content">{children}</div>
    </React.Fragment>
  );
};

export default LoginLayout;



// WEBPACK FOOTER //
// ./src/layouts/LoginLayout.js